module.exports = __webpack_public_path__ + "img/motorboat-2.73194ebb.svg";